/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';

// Components
import { CardHeaderActions } from 'components/content-containers/cards';
import Tooltip from 'components/widgets/overlays/tooltip';
import { EditButton, DeleteButton } from 'components/widgets/buttons';
import SVG from 'components/widgets/icons/svg';


export function PurchaseOrderActions({ purchaseOrder, edit }) {
  // const anyExpensesInvoiced = _.some(purchaseOrder.expenseBills, 'invoice');

  return (
    <CardHeaderActions>
      <DeleteButton
        title={purchaseOrder.expenseBills.length ? 'Can\'t delete a PO after any charges have been entered' : ''}
        onClick={() => archivePurchaseOrder(purchaseOrder.id).then(purchaseOrder.update)}
        disabled={purchaseOrder.expenseBills.length}
      />
      <EditButton onClick={edit} />
    </CardHeaderActions>
  );
}


export function Icon({ unbilledQuantity, quantity, unapprovedExpenseBills, status }) {
  if (status === 'Archived') {
    return <SVG src="svg/archived.svg" className="purchase no-margin" />;
  } else if (!unapprovedExpenseBills && unbilledQuantity === 0) {
    return (
      <Tooltip title="Fully charged and approved" className="inline-block">
        <SVG src="svg/fully-approved.svg" className="purchase" />
      </Tooltip>
    );
  } else if (unbilledQuantity === 0) {
    return (
      <Tooltip title="Fully charged, needs approval." className="inline-block">
        <SVG src="svg/fully-charged.svg" className="purchase" />
      </Tooltip>
    );
  } else if (unbilledQuantity !== quantity) {
    return (
      <Tooltip title="Partially charged." className="inline-block">
        <SVG src="svg/partially-charged.svg" className="purchase" />
      </Tooltip>
    );
  } else if (unbilledQuantity > 0) {
    return (
      <Tooltip title="Not charged." className="inline-block">
        <SVG src="svg/ordered.svg" className="purchase" />
      </Tooltip>
    );
  }

  return <div />;
}


// Helper function
function archivePurchaseOrder(id) {
  return PurchaseOrder.archive(id)
    .then((updatedPurchaseOrder) => ({
      id,
      purchaseOrderNumber: updatedPurchaseOrder.purchaseOrderNumber,
      status: updatedPurchaseOrder.status,
      recentlyArchived: true
    }))
    .catch(alerts.catchError);
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/purchase-card-header-components.js